document.addEventListener("DOMContentLoaded", () => {
  console.log("Scroll background utils loaded");

  // Add CSS to ensure background is visible and hero sections are transparent
  const style = document.createElement("style");

  // Get the first section's color for initial background
  const firstSectionWithColor = document.querySelector("[data-color]");
  const initialColor = firstSectionWithColor
    ? firstSectionWithColor.getAttribute("data-color")
    : "#ffffff";

  style.textContent = `
    html, body {
      min-height: 100vh;
      transition: background-color 0.5s ease;
      background-color: ${initialColor} !important;
    }
    
    /* Make ALL hero sections transparent so body background shows through */
    .hero {
      background-color: transparent !important;
    }
    
    /* Also make ALL hero containers transparent */
    .hero .hero__container {
      background-color: transparent !important;
    }
    
    /* Override any color scheme backgrounds on hero sections */
    .hero[class*="color-scheme-"] {
      background-color: transparent !important;
    }
    
    /* Ensure hero wrappers are also transparent */
    .hero-wrapper {
      background-color: transparent !important;
    }
    
    /* Override any section backgrounds that might be applied to hero sections */
    .section-wrapper.hero-wrapper {
      background-color: transparent !important;
    }
    
    /* Ensure footer sections maintain their own background color */
    footer,
    footer .section,
    .section-wrapper footer {
      background-color: var(--color-background) !important;
    }
  `;
  document.head.appendChild(style);

  // Get all sections with data-color, but exclude header announcement banners
  const allSections = [...document.querySelectorAll("[data-color]")];
  console.log("All sections with data-color:", allSections);

  const sections = allSections.filter((section) => {
    // Exclude announcement bars, header sections, and footer sections
    const isAnnouncementBar =
      section.classList.contains("announcement-bar") ||
      section.closest(".announcement-bar") !== null;
    const isHeaderSection =
      section.closest("header") !== null ||
      section.closest("#header-group") !== null;
    const isFooterSection =
      section.closest("footer") !== null || section.tagName === "FOOTER";
    const isHeroSection = section.classList.contains("hero");

    console.log("Checking section:", section, {
      isAnnouncementBar,
      isHeaderSection,
      isFooterSection,
      isHeroSection,
      classes: section.className,
    });

    if (isAnnouncementBar || isHeaderSection || isFooterSection) {
      console.log(
        "Excluding section:",
        section,
        "reason:",
        isAnnouncementBar
          ? "announcement bar"
          : isHeaderSection
            ? "header section"
            : "footer section"
      );
      return false;
    }

    // Special handling for hero sections - include them
    if (isHeroSection) {
      console.log("Including hero section:", section);
      return true;
    }

    return true;
  });

  console.log("Sections (filtered):", sections);

  // Log the data-color values for each section
  sections.forEach((section, index) => {
    const color = section.getAttribute("data-color");
    console.log(`Section ${index}:`, section, "data-color:", color);
  });

  let options = {
    threshold: [0.4],
  };

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  const handleIntersect = (entries) => {
    console.log("Intersection entries:", entries);
    entries.forEach((/** @type {IntersectionObserverEntry} */ entry) => {
      console.log(
        "Entry:",
        entry.target,
        "isIntersecting:",
        entry.isIntersecting
      );
      if (entry.isIntersecting) {
        const color = entry.target.getAttribute("data-color");
        console.log("Section color:", color);
        if (color) {
          document.body.style.setProperty(
            "background-color",
            color,
            "important"
          );
          console.log("Set body background to:", color);

          // Also set it on html element to ensure it's visible
          document.documentElement.style.setProperty(
            "background-color",
            color,
            "important"
          );
          console.log("Set html background to:", color);
        } else {
          console.log("No data-color attribute found");
        }
      }
    });
  };

  const observer = new IntersectionObserver(handleIntersect, options);

  sections.forEach((section) => {
    observer.observe(section);
  });

  // Log the initial background color that was set in CSS
  console.log("Set initial background color to:", initialColor);

  // Debug: Check all hero sections and force transparency
  setTimeout(() => {
    const allHeroSections = document.querySelectorAll(".hero");
    console.log("Found hero sections:", allHeroSections.length);

    allHeroSections.forEach((hero, index) => {
      const computedStyle = window.getComputedStyle(hero);
      const backgroundColor = computedStyle.backgroundColor;
      console.log(
        `Hero section ${index}:`,
        hero.id || hero.className,
        "Background color:",
        backgroundColor
      );

      // Force transparency on all hero sections
      if (hero instanceof HTMLElement) {
        hero.style.setProperty("background-color", "transparent", "important");
        console.log(`Forced transparency on hero section ${index}`);
      }

      // Also force transparency on hero containers
      const heroContainer = hero.querySelector(".hero__container");
      if (heroContainer && heroContainer instanceof HTMLElement) {
        heroContainer.style.setProperty(
          "background-color",
          "transparent",
          "important"
        );
        console.log(`Forced transparency on hero container ${index}`);
      }
    });
  }, 100);
});
